unit UWaitingList;

interface

uses
  System.Contnrs, UWaitingModel, WebLib.ExtCtrls, WebLib.REST, WebLib.Controls,
  UStampModel, UEssentialHelper, System.SysUtils, WebLib.JSON, UPictureModel;

type
  TWaitingList = class(TObjectList)
  private
    Client: TRestClient;
    ListTimer: TTimer;
    Locked: Boolean;
    FUrl: string;
    FOnListChanged: TCallback;
    function GetItem(i: Integer): TWaitingModel;
    procedure ErrorHandler(Sender: TObject; ARequest: TJSXMLHttpRequestRecord;
      Event: TJSEventRecord; var Handled: Boolean);
    procedure DoListChanged;
    procedure Execute;
    procedure OnTimer(Sender: TObject);
    procedure PictureInsert(Picture: TPictureModel);
    procedure Response(Sender: TObject; AResponse: string);
    procedure StampInsert(Stamp: TStampModel);
    procedure SetOnListChanged(const Value: TCallback);
  public
    constructor Create(Url: string);
    function ToJson: string;
    procedure Add(Item: TWaitingModel);
    procedure SetValues(JSON: string);
    procedure Sort;
    property Items[i: Integer]: TWaitingModel read GetItem;
    property Url: string read FUrl;
    property OnListChanged: TCallback read FOnListChanged
      write SetOnListChanged;
  end;

implementation

uses
  Js, WebLib.Storage;

{ TWaitingList }

procedure TWaitingList.Add(Item: TWaitingModel);
begin
  inherited Add(Item);
  Self.Sort;
  ListTimer.Enabled := true;
  Self.DoListChanged;
end;

constructor TWaitingList.Create(Url: string);
var
  s: string;
begin
  inherited Create;
  Locked := false;
  Self.FUrl := Url;
  ListTimer := TTimer.Create(nil);
  ListTimer.Interval := 15000;
  ListTimer.OnTimer := Self.OnTimer;
  Client := TRestClient.Create(nil);
  Client.OnResponse := Self.Response;
  Client.OnError := Self.ErrorHandler;
  Self.OnListChanged := nil;
  s := TLocalStorage.GetValue(Self.Url + '_WaitingList');
  s := '';
  if s <> '' then
    Self.SetValues(s)
  else
    TLocalStorage.RemoveKey(Self.Url + '_WaitingList');
  ListTimer.Enabled := Self.Count > 0;
end;

procedure TWaitingList.DoListChanged;
var
  key: string;
begin
  key := Self.Url + '_WaitingList';
  if Self.Count > 0 then
    TLocalStorage.SetValue(key, Self.ToJson)
  else
    TLocalStorage.RemoveKey(key);
  if Assigned(Self.OnListChanged) then
    Self.OnListChanged(Self);
end;

procedure TWaitingList.ErrorHandler(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; Event: TJSEventRecord;
  var Handled: Boolean);
begin
  Handled := true;
  Self.Response(Self, '');
end;

procedure TWaitingList.Execute;
var
  Item: TWaitingModel;
  Stamp: TStampModel;
  Picture: TPictureModel;
begin
  if (Self.Count > 0) then
  begin
    if not Locked then
    begin
      Locked := true;
      Item := Self.Items[0];
      case Item.ModelKind of
        mkUnknown:
          ;
        mkStamp:
          begin
            Stamp := Item.ToStampModel;
            if Stamp <> nil then
            begin
              case Item.JobKind of
                jkUnknown:
                  ;
                jkInsert:
                  Self.StampInsert(Stamp);
              end;
            end;
          end;
        mkPicture:
          begin
            Picture := Item.ToPictureModel;
            if Picture <> nil then
            begin
              case Item.JobKind of
                jkUnknown:
                  ;
                jkInsert:
                  Self.PictureInsert(Picture);
              end;
            end;
          end;
      end;
    end;
  end
  else
  begin
    ListTimer.Enabled := false;
    Locked := false;
  end;
end;

function TWaitingList.GetItem(i: Integer): TWaitingModel;
begin
  Result := inherited GetItem(i) as TWaitingModel;
end;

procedure TWaitingList.OnTimer(Sender: TObject);
begin
  Client.HttpsGet(Self.Url + '/TestService/Ping');
end;

procedure TWaitingList.PictureInsert(Picture: TPictureModel);
  procedure Callback(Sender: TObject);
  begin
    if (Sender is TPictureModel) and (Sender as TPictureModel).Result.ResultValue
    then
    begin
      Self.Delete(0);
      ListTimer.Enabled := Self.Count > 0;
      Locked := false;
      Self.DoListChanged;
    end;
  end;

  procedure Unlock(Sender: TObject; AMsg: string);
  begin
    Locked := false;
  end;

begin
  Picture.OnConfirmation := Callback;
  Picture.OnError := Unlock;
  Picture.Insert(Self.Url);
end;

procedure TWaitingList.Response(Sender: TObject; AResponse: string);
var
  jso: TJsObject;
begin
  if AResponse <> '' then
  begin
    jso := TJsJson.parseObject(AResponse);
    if (jso['value'] <> nil) and (string(jso['value']) = '1') then
      Self.Execute;
  end;
end;

procedure TWaitingList.SetOnListChanged(const Value: TCallback);
begin
  FOnListChanged := Value;
end;

procedure TWaitingList.SetValues(JSON: string);
var
  obj: TJsObject;
  Count, i: Integer;
begin
  Self.Clear;
  obj := TJsJson.parseObject(JSON);
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
        Self.Add(TWaitingModel.Create(string(obj['Item' + IntToStr(i)])));
  end;
end;

procedure TWaitingList.Sort;
var
  i, j: Integer;
begin
  if Self.Count > 1 then
  begin
    for i := 0 to Self.Count - 2 do
      for j := i to Self.Count - 2 do
        if Self.Items[j].Created > Self.Items[j + 1].Created then
          Self.Exchange(j, j + 1);
  end;
end;

procedure TWaitingList.StampInsert(Stamp: TStampModel);
  procedure Callback(Sender: TObject);
  begin
    if (Sender is TStampModel) and (Sender as TStampModel).Result.ResultValue
    then
    begin
      Self.Delete(0);
      ListTimer.Enabled := Self.Count > 0;
      Locked := false;
      Self.DoListChanged;
    end;
  end;

  procedure Unlock(Sender: TObject; AMsg: string);
  begin
    Locked := false;
  end;

begin
  Stamp.OnPropertyChanged := Callback;
  Stamp.OnError := Unlock;
  Stamp.Insert(Self.Url);
end;

function TWaitingList.ToJson: string;
var
  obj: TJsonObject;
  i: Integer;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Count', IntToStr(Self.Count));
  for i := 0 to Self.Count - 1 do
    obj.AddPair('Item' + IntToStr(i), Self.Items[i].ToJson);
  Result := obj.ToJson;
  obj.Free;
end;

end.
